import StarRating from '@app-studio-web/ui/components/StarRating'
import { useTranslation } from 'react-i18next'

export default function SocialProofBanner() {
  const { t } = useTranslation()

  return (
    <div className="bg-primary/5 border-primary/20 rounded-2xl border px-5 py-4 text-center">
      <div className="mb-1 flex items-center justify-center gap-2">
        <StarRating rating={4.7} />
        <span className="text-sm font-semibold">4.7/5</span>
      </div>
      <p className="text-custom-black text-sm">
        {t('pages.checkout.socialProofBanner')}
      </p>
    </div>
  )
}
